import { VISIT_INTERVAL_OPTIONS } from '~services/constant/customer';
import HelperOptions from '~component/helper/helper-options';

// 客户拜访间隔
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ VISIT_INTERVAL_OPTIONS }
      />
    );
  },
};
